import { type AxiosError } from "axios";

export const MAX_QUERY_RETRIES = 3;

/**
 * Default TanStack Query retry policy. A 4xx response is a definitive client
 * error (auth, not-found, validation) — retrying only delays the inevitable
 * error, which is why an unauthorized preview used to spin for seconds before
 * showing "keine Berechtigung". Fail fast on 4xx; keep retrying transient
 * network/5xx failures up to MAX_QUERY_RETRIES.
 *
 * Two 4xx statuses deserve a note: 408 (request timeout) is transient like a
 * network failure, so it stays retryable. 429 (rate limited) is deliberately
 * NOT retried — hammering an already rate-limited endpoint makes it worse.
 */
export function retryUnlessClientError(
  failureCount: number,
  error: unknown
): boolean {
  const status = (error as AxiosError)?.response?.status;
  const isRequestTimeout = status === 408;
  if (
    status !== undefined &&
    status >= 400 &&
    status < 500 &&
    !isRequestTimeout
  ) {
    return false;
  }

  return failureCount < MAX_QUERY_RETRIES;
}
